export default {
	componentAttribute: 'component',
	componentContextAttribute: 'componentContext',
	contextAttribute: 'context',
	currentContextAttribute: 'currentContext'
};
